
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='myLibraryButtons'>\r\n  <button class='btn-lib watched js-watched-btn' data-index='watched'>WATCHED</button>\r\n  <button class='btn-lib queue js-queue-btn' data-index='queue'>QUEUE</button>\r\n</div>";
},"useData":true});
                export default templateFunction;
                